import {
  IconButton,
  Popover,
  TextField,
} from '@material-ui/core';
import { Event } from '@material-ui/icons';
import React, { useRef, useState } from 'react';

import KPTimePickerForm from './KPTimePickerForm';

// Refactor 2026-08-10: Dialog cũ (dùng PaperComponent tự tính vị trí) gây
// xung đột aria-hidden/focus-trap khi KPTimePicker được mở từ bên trong 1
// Dialog khác đang mở (vd SettingForm) — 2 Modal chồng nhau khiến cả màn hình
// bị khoá, không bấm được gì. Đổi sang Popover neo theo anchorEl, cùng pattern
// đã chạy ổn định ở KPMonthYearPicker (dùng Menu, cũng là Popover).
function KPTimePicker(props) {
  const formRef = useRef();

  const { disabled } = props;

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = () => setAnchorEl(null);
  const handleClick = () => { if (!disabled) setAnchorEl(formRef.current); }

  const handleChangeForm = (value) => {
    props.handleChangeForm(value);
    formRef.current.blur();
    handleClose();
  }

  return (
    <>
      <TextField
        ref={formRef}
        fullWidth
        size='small'
        variant='outlined'
        value={props.value || ''}
        placeholder='dd/mm/yyyy'
        disabled={props.disabled}
        required={props.required}
        inputProps={{ style: { padding: 8, caretColor: 'transparent' } }}
        onClick={handleClick}
        InputProps={{
          endAdornment: (
            <IconButton size='small' onClick={handleClick} disabled={props.disabled}>
              <Event fontSize='small' />
            </IconButton>
          )
        }}
      />

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        keepMounted
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        PaperProps={{
          style: {
            width: Math.max(formRef.current?.offsetWidth || 0, 360),
            padding: '16px 8px',
          },
        }}
      >
        <KPTimePickerForm
          open={Boolean(anchorEl)}
          disabledDate={props.disabledDate}
          value={props.value || "dd/mm/yyyy"}
          handleChangeForm={handleChangeForm}
          handleClose={handleClose}
        />
      </Popover>
    </>
  )
}

export default KPTimePicker;
